<template>
  <div class="">
    <Dialog :expanderClass="'d-inline'" ref="dialogRef">
      <template #expander="{ openModal }">
        <ButtonCustomized
          @click="openModal"
          :disabled="matchingPlayersCount === 0 || isLoadingPlayersCount"
          :label="`Matching Players ${
            isLoadingPlayersCount
              ? '...'
              : `(${matchingPlayersCount || 'None'})`
          }`"
          style="width: fit-content; background-color: #2a7cd7;"
        />
      </template>
      <template #dialog.title>
        {{ dialogTitle }}
      </template>
      <template #dialog.content="{ closeModal, closeModalAfter }">
        <!-- TODO (cleaner code): think about removing redundancy between "DeleteItemConfirmationForm" & other forms (e.g. CreateSlideForm) [DSP-N26Dui5A] -->
        <div class="container">
          <SimpleEntityListingPage
            entityItemsNamePlural=""
            entityItemName="''"
            :areaAccessName="areaAccessName"
            :ItemsLister="MatchingPlayersLister"
            :itemsListerBind="{ filters }"
          />
          <div class="form-buttons">
            <ButtonCustomized label="Close" @click="closeModal" style="width: fit-content;" />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue';
import { usePlayerSubscription } from '../../composables/playerSubscription';
import { fetchMatchingPlayers } from '@/helpers/api/player-subscription/fetch';
import Dialog from '@/components/Dialog/Dialog.vue';
import SimpleEntityListingPage from '@/components/ListingPages/SimpleEntityListingPage/SimpleEntityListingPage.vue';
import ButtonCustomized from '@/components/form-fields/ButtonCustomized.vue';
import MatchingPlayersLister from './MatchingPlayersLister.vue';
import { throttle } from '@/helpers/utils';

const props = defineProps(["filters"]);

// Dialog / List Config
const dialogTitle = "Preview Matching Players";
const areaAccessName = "Administration";

const { prepareFiltersForSubmission } = usePlayerSubscription();

const isLoadingPlayersCount = ref(false);
const matchingPlayersCount = ref(0);

// Setup matching players count helper watcher
onMounted(async () => await updateMatchingPlayersCount(props.filters));
watch(() => props.filters, throttle(async () => {
  await updateMatchingPlayersCount(props.filters);
}, 1000), { deep: true });

// -------- Matching Players Count Helpers --------
async function updateMatchingPlayersCount(filters: any) {
  isLoadingPlayersCount.value = true;
  matchingPlayersCount.value = await getMatchingPlayersCount(filters);
  isLoadingPlayersCount.value = false;
}

async function getMatchingPlayersCount(filters: any) {
  const filtersPayload = prepareFiltersForSubmission(filters);
  const response = await fetchMatchingPlayers(filtersPayload);
  return response.matchedPlayers.length;
}
</script>

<style lang="scss" scoped>
.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1rem;
}

.add-link {
  border: 0;
  cursor: pointer;
  display: inline-block;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 6px;
  text-transform: uppercase;
  color: rgba(37, 41, 74, 0.5);
  font-weight: bold;
}

.add-link:hover {
  text-decoration: underline;
}

/* START: Lister Dialog Sizing Fix */
/* TODO: To think about how to fix this problem in all other listing and all other screen widths*/
/* Help fix width & height of Lister Dialog */
.container { 
  @include x-large-devices-up {
    /* width: 75rem; */
    /* width: 65rem; */
  }
  @media screen and (min-width: 1200px) and (max-width: 862px) {
    /* width: 30rem; */
  }
}

:deep(.list-section-container) {
  @media screen and (min-width: 1040px) {
    width: 60rem;
  }
  @media screen and (min-width: 950px) and (max-width: 1040px) {
    width: 55rem;
  }
  @media screen and (min-width: 870px) and (max-width: 950px) {
    width: 50rem;
  }
  @media screen and (min-width: 710px) and (max-width: 870px) {
    width: 40rem;
  }
  height: fit-content;
  padding-bottom: 0;
}
/* END: Lister Dialog Sizing Fix */
</style>